import axios from "services/axios";
import {useMutation, useQueryClient} from "react-query";

import {QUERY_ARTICLE_POST} from "./useQueryArticlePost";

export function useDeleteArticlePost(options = {}) {
	const queryClient = useQueryClient();

	return useMutation(values => axios.post("/article/delete", values).then(res => res.data), {
		onSuccess: () => {
			queryClient.invalidateQueries(QUERY_ARTICLE_POST);
			queryClient.removeQueries(QUERY_ARTICLE_POST);
		},
		...options,
	});
}
